module.exports = __webpack_public_path__ + "static/media/anchor.f414b4a7.svg";